import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromDeviceMonitoring from './reducers/device-monitoring.reducer';
import { EffectsModule } from '@ngrx/effects';
import { DeviceMonitoringEffects } from './effects/device-monitoring.effects';
import * as fromDeviceMonitoringFilter from './reducers/device-monitoring-filter.reducer';
import { DeviceMonitoringFilterEffects } from './effects/device-monitoring-filter.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('deviceMonitoring', fromDeviceMonitoring.reducer),
    EffectsModule.forFeature([DeviceMonitoringEffects, DeviceMonitoringFilterEffects]),
    StoreModule.forFeature('deviceMonitoringFilter', fromDeviceMonitoringFilter.reducer)
  ]
})
export class DeviceMonitoringModule { }
